import { useNavigate } from 'react-router-dom';
import Layout from '../layout/layout';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  IconButton,
  Tooltip,
  Drawer,
  CircularProgress,
  Popover,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
} from '@mui/material';
import { FloatingButton, MinimalSingleSelect } from '../common/form-control';
import SearchComponent from '../common/search';
import { useState, useEffect, useContext } from 'react';
import {
  NoRecordFoundBox,
  DialogPrompt,
  StatusComponent,
} from '../common/other-component';
import NoBadgesFoundImage from '../../assets/images/no-annoucement.png';
import {
  Edit,
  MoreVert,
  CloseOutlined,
  Visibility,
  CheckCircleOutlined,
  Close,
  Delete,
  UnpublishedOutlined,
} from '@mui/icons-material';
import ENUMS from '../../constants/enum';
import getUserRole from '../../helpers/getuser-role';
import {
  badgesAction,
  badgesListData,
  deleteBadge,
  updateBadgeSequence,
} from '../../services/badge-service';
import _ from 'lodash';
import TableLoader from '../common/table-loader';
import { Toast } from '../common/toast-utils';
import { SkandikaContextData } from '../../context';

function Badges() {
  const navigate = useNavigate();
  const checkUserRole = new getUserRole();
  const { refetchPendingCountData, handleBadgeExist, contextData, setBadgesFilters } =
    useContext(SkandikaContextData);
  
  const savedFilters = contextData.badgesFilters || {};
  
  const [searchString, setSearchString] = useState(savedFilters.searchString || '');
  const [orderBy, setOrderBy] = useState(savedFilters.orderBy || '');
  const [order, setOrder] = useState(savedFilters.order || 'asc');
  const [page, setPage] = useState(savedFilters.page || 0);
  const [isOpen, setIsOpen] = useState(false);
  const [filterStatus, setFilterStatus] = useState(savedFilters.filterStatus || null);
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [size, setSize] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [isDelteItem, setDeleteItem] = useState(false);
  const [pageindex, setPageIndex] = useState(savedFilters.pageindex || 1);
  const [pagesize, setPageSize] = useState(savedFilters.pagesize || ENUMS.DEFAULT_PAGESIZE);
  const [reRender, setRender] = useState(0);
  
  const addBadges = () => {
    navigate(ENUMS.ROUTES.BADGES.ADD);
  };
  
  useEffect(() => {
    const filtersToSave = {
      searchString,
      orderBy,
      order,
      page,
      filterStatus,
      pageindex,
      pagesize,
    };
    setBadgesFilters(filtersToSave);
  }, [searchString, orderBy, order, page, filterStatus, pageindex, pagesize, setBadgesFilters]);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const sorting = order === 'desc' ? `-${orderBy}` : orderBy;
        const request = {
          page_index: pageindex,
          page_size: pagesize,
          status:
            filterStatus && filterStatus.value ? filterStatus.value : undefined,
          search: searchString,
          ordering: sorting,
        };
        const res = await badgesListData(request);
        if (res.success) {
          setRows(res.data.results || []);
          setSize(res.data.count || 0);
          if (res.data.results.length > 0) {
            handleBadgeExist(true);
          } else if (
            contextData &&
            contextData.isBadgeExist &&
            !res.data.results.length
          ) {
            handleBadgeExist(false);
          }
        } else {
          setRows([]);
        }
      } catch (error) {
        setRows([]);
      }
      setLoading(false);
    })();
  }, [reRender, pageindex, pagesize, searchString, order, orderBy]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setPageIndex(newPage + 1);
  };
  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setPageIndex(1);
    setPageSize(parseInt(event.target.value, 10));
  };

  const getStatus = (row) => {
    if (_.isEmpty(row.status_display)) {
      return '';
    }
    const item = [...ENUMS.ANNOUNCEMENT_STATUS].find(
      (d) => d.label.toLowerCase() === row.status_display.toLowerCase()
    );
    if (item) {
      return (
        <StatusComponent color={item.color} label={item.label} size='small' />
      );
    } else {
      return '';
    }
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAction = async (action) => {
    if (action === 'PUBLISH')
      await updateStatus(ENUMS.ACTION_STATUS_ENUM.Published, selectedRow.id);
    else if (action === 'REJECT')
      await updateStatus(ENUMS.ACTION_STATUS_ENUM.Rejected, selectedRow.id);
    else if (action === 'UNPUBLISH')
      await updateStatus(ENUMS.ACTION_STATUS_ENUM.Unpublish, selectedRow.id);
    else if (action === 'DELETE') setDeleteItem(true);
    setAnchorEl(null);
  };

  const updateStatus = async (action_status, id) => {
    setActionLoading(true);
    try {
      let payload = {
        status: action_status,
      };
      const res = await badgesAction(id, payload);
      if (res.success) {
        Toast.success(res.data.detail);
        setRender((p) => p + 1);
        await refetchPendingCountData();
      } else {
        Toast.error(res.error_message);
      }
    } catch (error) {
      Toast.error(error);
    }
    setActionLoading(false);
  };

  const handleBadgesItem = (item) => {
    if (
      checkUserRole.isAdmin() &&
      !_.isEmpty(item.status) &&
      (item.status.toLowerCase() ===
        ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
        item.status.toLowerCase() ===
          ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase() ||
        item.status.toLowerCase() ===
          ENUMS.ANNOUNCEMENT_STATUS_ENUM.Pending.toLowerCase() ||
        item.status.toLowerCase() ===
          ENUMS.ANNOUNCEMENT_STATUS_ENUM.PendingForApproval.toLowerCase())
    ) {
      navigate(ENUMS.ROUTES.BADGES.EDIT + item.id);
    } else if (
      checkUserRole.isStaff() &&
      item.editable &&
      !_.isEmpty(item.status) &&
      (item.status.toLowerCase() ===
        ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
        item.status.toLowerCase() ===
          ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase())
    ) {
      navigate(ENUMS.ROUTES.BADGES.EDIT + item.id);
    } else {
      navigate(ENUMS.ROUTES.BADGES.VIEW + item.id);
    }
  };

  const handleFilterStatusChange = (val) => setFilterStatus(val);
  const handleApplyFilter = async () => {
    setIsOpen(false);
    try {
      setPage(0);
      setPageIndex(1);
      setPageSize(ENUMS.DEFAULT_PAGESIZE);
      setOrderBy('');
      const sorting = order === 'desc' ? '-' + orderBy : orderBy;
      let request = {
        page_index: 1,
        page_size: ENUMS.DEFAULT_PAGESIZE,
        status:
          filterStatus && filterStatus.value ? filterStatus.value : undefined,
        search: searchString,
        ordering: sorting,
      };
      const res = await badgesListData(request);
      if (res.success) {
        const list_data = res.data.results
          ? res.data.results.map((e) => ({
              ...e,
              badge_id: 'Badge ' + e.id,
            }))
          : [];
        setSize(res.data.count);
        setRows(list_data);
      } else {
        setRows([]);
        Toast.error(res.error_message);
      }
      setLoading(false);
    } catch (error) {
      setRows([]);
      setLoading(false);
    }
  };

  const handleClearFilter = () => {
    setIsOpen(false);
    setRender((p) => p + 1);
    setFilterStatus(null);
  };

  const labelDisplayedRows = ({ count }) => {
    // Calculate the total number of pages based on the total number of rows and rows per page
    const totalPages = Math.ceil(count / pagesize);
    return `Page ${pageindex} of ${totalPages}`;
  };

  const confirmDelete = async () => {
    setActionLoading(true);
    try {
      const res = await deleteBadge(selectedRow.id);
      if (res.success) {
        setDeleteItem(false);
        Toast.success(res.data.detail);
        setRender((p) => p + 1);
        await refetchPendingCountData();
      } else {
        Toast.error(res.error_message);
      }
    } catch (error) {
      Toast.error(error);
    }
    setActionLoading(false);
  };

  const [isSequenceDialogOpen, setSequenceDialogOpen] = useState(false);
  const [selectedBadgeForSequence, setSelectedBadgeForSequence] =
    useState(null);
  const [newSequence, setNewSequence] = useState('');
  const [sequenceError, setSequenceError] = useState('');

  const handleOpenSequenceDialog = (badge) => {
    setSelectedBadgeForSequence(badge);
    setNewSequence(badge.sequence || '');
    setSequenceError('');
    setSequenceDialogOpen(true);
  };

  const handleUpdateSequence = async () => {
    if (!selectedBadgeForSequence) return;

    // Validate sequence number
    if (!newSequence || String(newSequence).trim() === '') {
      setSequenceError('Sequence number is required');
      return;
    }

    setActionLoading(true);
    try {
      const res = await updateBadgeSequence(
        selectedBadgeForSequence.id,
        newSequence
      );
      if (res.success) {
        Toast.success('Sequence updated successfully');
        setRender((p) => p + 1);
        setSequenceDialogOpen(false);
      } else {
        Toast.error(res.error_message || 'Failed to update sequence');
      }
    } catch (error) {
      Toast.error(error?.error_message || 'Failed to update sequence');
    }
    setActionLoading(false);
    setAnchorEl(null);
    setSelectedRow(null);
  };

  return (
    <Layout>
      <Box component='div' mb={2}>
        <Grid
          container
          sx={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Grid item>
            <FloatingButton
              text='Filter'
              baseClassName='common-btn'
              sx={{ marginRight: '10px' }}
              onClick={() => setIsOpen(true)}
            />
            <FloatingButton
              text='Add Badges'
              baseClassName='common-btn'
              onClick={() => addBadges()}
            />
          </Grid>
          <Grid item>
            <SearchComponent
              searchString={searchString}
              setSearchString={setSearchString}
            />
          </Grid>
        </Grid>
      </Box>
      <div className='dashboardtblScroll theme-scroll-bar' id='style-1'>
        {_.isEmpty(rows) && !loading ? (
          <NoRecordFoundBox img_url={NoBadgesFoundImage} />
        ) : (
          <Table size='small' stickyHeader={true}>
            <TableHead>
              <TableRow>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'sequence'}
                    direction={orderBy === 'sequence' ? order : 'asc'}
                    onClick={() => handleRequestSort('sequence')}
                  >
                    Sequence
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'badge_title'}
                    direction={orderBy === 'badge_title' ? order : 'asc'}
                    onClick={() => handleRequestSort('badge_title')}
                  >
                    Badge Name
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'targeted_distance'}
                    direction={orderBy === 'targeted_distance' ? order : 'asc'}
                    onClick={() => handleRequestSort('targeted_distance')}
                  >
                    Distance
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  Operator
                </TableCell>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'targeted_time'}
                    direction={orderBy === 'targeted_time' ? order : 'asc'}
                    onClick={() => handleRequestSort('targeted_time')}
                  >
                    Time
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'created_by'}
                    direction={orderBy === 'created_by' ? order : 'asc'}
                    onClick={() => handleRequestSort('created_by')}
                  >
                    Created By
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  <TableSortLabel
                    active={orderBy === 'status'}
                    direction={orderBy === 'status' ? order : 'asc'}
                    onClick={() => handleRequestSort('status')}
                  >
                    Status
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  align='left'
                  padding='normal'
                  style={{
                    width: '10%',
                    backgroundColor: ENUMS.THEME.LIGHT_COLOR,
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableLoader cols={7} />
            ) : (
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {row.sequence || '-'}
                    </TableCell>
                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {row.description?.title?.en}
                    </TableCell>
                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {row.targeted_distance || '-'}
                    </TableCell>
                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {row.distance_op || '-'}
                    </TableCell>
                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {row.targeted_time || '-'}
                    </TableCell>
                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {row.staff_user_name || '-'}
                    </TableCell>
                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {' '}
                      {getStatus(row)}
                    </TableCell>

                    <TableCell
                      style={ENUMS.COMMON_STYLE.tableStyle().tableBodyCellStyle}
                    >
                      {checkUserRole.isStaff() && (
                        <>
                          {row.editable &&
                          !_.isEmpty(row.status) &&
                          (row.status.toLowerCase() ===
                            ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
                            row.status.toLowerCase() ===
                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase()) ? (
                            <Tooltip
                              title='Edit'
                              placement='top'
                              sx={{ zIndex: 1, pointerEvents: 'auto' }}
                              PopperProps={{ disablePortal: true }}
                            >
                              <IconButton
                                size='small'
                                onClick={() => handleBadgesItem(row)}
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Tooltip
                              title='View'
                              placement='top'
                              PopperProps={{ disablePortal: true }}
                            >
                              <IconButton
                                size='small'
                                onClick={() => handleBadgesItem(row)}
                              >
                                <Visibility />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      )}
                      {checkUserRole.isAdmin() && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {!_.isEmpty(selectedRow) &&
                          row.id === selectedRow.id &&
                          actionLoading ? (
                            <CircularProgress size={20} thickness={5} />
                          ) : (
                            <>
                              {!_.isEmpty(row.status) &&
                              (row.status.toLowerCase() ===
                                ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
                                row.status.toLowerCase() ===
                                  ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase() ||
                                row.status.toLowerCase() ===
                                  ENUMS.ANNOUNCEMENT_STATUS_ENUM.Pending.toLowerCase() ||
                                row.status.toLowerCase() ===
                                  ENUMS.ANNOUNCEMENT_STATUS_ENUM.PendingForApproval.toLowerCase()) ? (
                                <Tooltip
                                  title='Edit'
                                  placement='top'
                                  PopperProps={{ disablePortal: true }}
                                >
                                  <IconButton
                                    size='small'
                                    onClick={() => handleBadgesItem(row)}
                                  >
                                    <Edit />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title='View'
                                  placement='top'
                                  PopperProps={{ disablePortal: true }}
                                >
                                  <IconButton
                                    size='small'
                                    onClick={() => handleBadgesItem(row)}
                                  >
                                    <Visibility />
                                  </IconButton>
                                </Tooltip>
                              )}
                              {!_.isEmpty(row.status) &&
                                (row.status.toLowerCase() ===
                                  ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.Pending.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.PendingForApproval.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.Published.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.Active.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.ActiveSoon.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.Expired.toLowerCase() ||
                                  row.status.toLowerCase() ===
                                    ENUMS.ANNOUNCEMENT_STATUS_ENUM.Rejected.toLowerCase()) && (
                                  <>
                                    <Tooltip
                                      title='More Actions'
                                      placement='top'
                                      PopperProps={{ disablePortal: true }}
                                    >
                                      <IconButton
                                        onClick={(event) =>
                                          handleMenuClick(event, row)
                                        }
                                      >
                                        <MoreVert />
                                      </IconButton>
                                    </Tooltip>
                                    <Popover
                                      open={
                                        selectedRow === row && Boolean(anchorEl)
                                      }
                                      anchorEl={anchorEl}
                                      onClose={handleMenuClose}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                      }}
                                    >
                                      <List
                                        sx={{
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        {!_.isEmpty(row.status) &&
                                          (row.status.toLowerCase() ===
                                            ENUMS.ANNOUNCEMENT_STATUS_ENUM.Pending.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.PendingForApproval.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase()) && (
                                            <>
                                              <ListItemButton
                                                style={
                                                  ENUMS.COMMON_STYLE.tableStyle()
                                                    .popOverListItemStyle
                                                }
                                                onClick={() =>
                                                  handleAction('PUBLISH')
                                                }
                                                disabled={actionLoading}
                                              >
                                                <ListItemIcon
                                                  sx={
                                                    ENUMS.COMMON_STYLE.tableStyle()
                                                      .popOverListItemIconStyle
                                                  }
                                                  style={{ color: '#4BAE4F' }}
                                                >
                                                  <CheckCircleOutlined />
                                                </ListItemIcon>
                                                <ListItemText primary='Publish' />
                                              </ListItemButton>
                                              <ListItemButton
                                                style={
                                                  ENUMS.COMMON_STYLE.tableStyle()
                                                    .popOverListItemStyle
                                                }
                                                onClick={() =>
                                                  handleAction('REJECT')
                                                }
                                                disabled={actionLoading}
                                              >
                                                <ListItemIcon
                                                  sx={
                                                    ENUMS.COMMON_STYLE.tableStyle()
                                                      .popOverListItemIconStyle
                                                  }
                                                  style={{ color: '#EE404C' }}
                                                >
                                                  <Close />
                                                </ListItemIcon>
                                                <ListItemText primary='Reject' />
                                              </ListItemButton>
                                            </>
                                          )}
                                        {!_.isEmpty(row.status) &&
                                          (row.status.toLowerCase() ===
                                            ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Pending.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.PendingForApproval.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Expired.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Rejected.toLowerCase()) && (
                                            <ListItemButton
                                              style={
                                                ENUMS.COMMON_STYLE.tableStyle()
                                                  .popOverListItemStyle
                                              }
                                              onClick={() =>
                                                handleAction('DELETE')
                                              }
                                              disabled={actionLoading}
                                            >
                                              <ListItemIcon
                                                sx={
                                                  ENUMS.COMMON_STYLE.tableStyle()
                                                    .popOverListItemIconStyle
                                                }
                                                style={{ color: '#FC0005' }}
                                              >
                                                <Delete />
                                              </ListItemIcon>
                                              <ListItemText primary='Delete' />
                                            </ListItemButton>
                                          )}
                                        {!_.isEmpty(row.status) &&
                                          (row.status.toLowerCase() ===
                                            ENUMS.ANNOUNCEMENT_STATUS_ENUM.Published.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Active.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.ActiveSoon.toLowerCase()) && (
                                            <ListItemButton
                                              style={
                                                ENUMS.COMMON_STYLE.tableStyle()
                                                  .popOverListItemStyle
                                              }
                                              onClick={() =>
                                                handleAction('UNPUBLISH')
                                              }
                                              disabled={actionLoading}
                                            >
                                              <ListItemIcon
                                                sx={
                                                  ENUMS.COMMON_STYLE.tableStyle()
                                                    .popOverListItemIconStyle
                                                }
                                                style={{ color: '#FC0005' }}
                                              >
                                                <UnpublishedOutlined />
                                              </ListItemIcon>
                                              <ListItemText primary='Unpublish' />
                                            </ListItemButton>
                                          )}
                                        {!_.isEmpty(row.status) &&
                                          (row.status.toLowerCase() ===
                                            ENUMS.ANNOUNCEMENT_STATUS_ENUM.Draft.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Unpublish.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Published.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Pending.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.PendingForApproval.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Expired.toLowerCase() ||
                                            row.status.toLowerCase() ===
                                              ENUMS.ANNOUNCEMENT_STATUS_ENUM.Rejected.toLowerCase()) && (
                                            <ListItemButton
                                              style={
                                                ENUMS.COMMON_STYLE.tableStyle()
                                                  .popOverListItemStyle
                                              }
                                              onClick={() =>
                                                handleOpenSequenceDialog(row)
                                              }
                                              disabled={actionLoading}
                                            >
                                              <ListItemIcon
                                                sx={
                                                  ENUMS.COMMON_STYLE.tableStyle()
                                                    .popOverListItemIconStyle
                                                }
                                                style={{ color: '#007bff' }}
                                              >
                                                <Edit />
                                              </ListItemIcon>
                                              <ListItemText primary='Update Sequence' />
                                            </ListItemButton>
                                          )}
                                      </List>
                                    </Popover>
                                  </>
                                )}
                            </>
                          )}
                        </div>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        )}
      </div>
      {!_.isEmpty(rows) && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          component='div'
          count={size}
          rowsPerPage={pagesize}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={labelDisplayedRows}
          labelRowsPerPage={ENUMS.ROWS_PER_PAGETEXT}
        />
      )}
      {/* DialogPrompt for delete confirmation */}
      <DialogPrompt
        open={isDelteItem}
        onCancel={() => setDeleteItem(false)}
        onConfirm={() => confirmDelete()}
        title='Are you sure you want to delete this badge?'
        loading={actionLoading}
      />
      {/* Filter Drawer */}
      <Drawer
        anchor='right'
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className='sidebar-drawer'
      >
        <div className='sidebar-drawer-header' style={{ width: '100%' }}>
          <div>Filter </div>
          <IconButton
            aria-label='close'
            size='small'
            onClick={() => setIsOpen(false)}
          >
            <CloseOutlined style={{ color: '#fff' }} />
          </IconButton>
        </div>
        <div
          className='table-responsive'
          id='style-1'
          style={{
            maxHeight: 'calc(100vh - 65px)',
            height: 'calc(100vh - 65px)',
            width: '450px',
          }}
        >
          <div style={{ padding: '10px' }}>
            <MinimalSingleSelect
              placeholder='Select Status'
              value={filterStatus}
              options={[...ENUMS.BADGES_STATUS_LIST]}
              onInputChange={handleFilterStatusChange}
            />
          </div>
        </div>
        <div className='sidebar-drawer-footer'>
          <FloatingButton
            baseClassName={`common-btn ${
              !filterStatus ? 'common-btn-gray' : ''
            }`}
            text='Clear All'
            onClick={handleClearFilter}
            sx={{ marginRight: '5px' }}
            disabled={!filterStatus}
          />
          <FloatingButton
            baseClassName='common-btn'
            text='Apply'
            onClick={handleApplyFilter}
            disabled={!filterStatus}
          />
        </div>
      </Drawer>
      <DialogPrompt
        open={isSequenceDialogOpen}
        onCancel={() => setSequenceDialogOpen(false)}
        onConfirm={handleUpdateSequence}
        title='Update Sequence Number'
        loading={actionLoading}
      >
        <TextField
          type='number'
          value={newSequence}
          onChange={(e) => {
            setNewSequence(e.target.value.replace(/[^0-9]/g, ''));
            if (e.target.value.trim() !== '') {
              setSequenceError('');
            }
          }}
          min={1}
          label='Sequence Number'
          variant='outlined'
          fullWidth
          autoFocus
          error={!!sequenceError}
          helperText={sequenceError}
          sx={{
            mt: 2,
            mb: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: '8px',
            },
            '& .MuiInputLabel-root': {
              fontWeight: 500,
            },
          }}
          inputProps={{
            style: { fontSize: 18, padding: '12px' },
            min: 1,
          }}
        />
      </DialogPrompt>
    </Layout>
  );
}

export default Badges;
